import { BaseApiService } from '@/shared/api/services/base.service';

export interface LegalDocumentAttributes {
  document_type: string;
  locale: string;
  title: string;
  last_updated: string;
  content: string;
  checksum: string;
}

interface LegalDocumentResponse {
  data: {
    type: string;
    id: string;
    attributes: LegalDocumentAttributes;
  };
}

class LegalDocumentsService extends BaseApiService {
  async get(
    type: 'privacy' | 'terms',
    locale: string
  ): Promise<LegalDocumentAttributes> {
    const response = await this.httpGet<LegalDocumentResponse>(
      `/v1/legal/${type}?locale=${locale}`
    );
    return response.data.attributes;
  }
}

export const legalDocumentsService = new LegalDocumentsService();
